enum BetDirection {
  long,
  short,
}

export default BetDirection
